import React, { lazy, Suspense } from "react";

const DataItem = lazy(() => import("./dataItem.js"));

export default function RefuelingsVisitStatsReport(props) {
    return (
        <div className="row pt-3">
            <Suspense fallback={<div className="loading loading--small" />}>
                <DataItem data={props.data.data[0].count} postfix="шт" name="Кол-во запланированных заправок" />
            </Suspense>
            <Suspense fallback={<div className="loading loading--small" />}>
                <DataItem
                    data={props.data.data[0].factPrice}
                    planData={props.data.data[0].planPrice}
                    postfix={props.organization?.currencyData?.sign}
                    name="Стоимость топлива на посещенных заправках"
                />
            </Suspense>
            <Suspense fallback={<div className="loading loading--small" />}>
                <DataItem
                    data={props.data.data[0].factVolume}
                    planData={props.data.data[0].planVolume}
                    postfix="л"
                    name="Объем топлива на посещенных заправках"
                />
            </Suspense>
        </div>
    );
}
